import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=a2a1dac4&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./calendar.vue?vue&type=style&index=0&id=a2a1dac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a1dac4",
  null
  
)

export default component.exports